import React, { Component } from "react";

export default class MyLoader extends Component {
  render() {
    return (
      <div style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(255, 255, 255, 0.95)",
        backdropFilter: "blur(4px)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
        overflow: "hidden",
        pointerEvents: "all",
      }}>
        {/* Animated Progress Bar */}
        <div style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "3px",
          backgroundColor: "#e5e7eb",
          overflow: "hidden",
        }}>
          <div style={{
            height: "100%",
            width: "30%",
            background: "linear-gradient(90deg, transparent, #3b82f6, transparent)",
            animation: "shimmer 1.5s ease-in-out infinite",
          }} />
        </div>
        
        {/* Modern Spinner */}
        <div style={{
          width: "60px",
          height: "60px",
          position: "relative",
          marginBottom: "20px",
        }}>
          <div style={{
            width: "100%",
            height: "100%",
            border: "4px solid #e5e7eb",
            borderTop: "4px solid #3b82f6",
            borderRadius: "50%",
            animation: "spin 0.8s linear infinite",
          }} />
          <div style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "40px",
            height: "40px",
            border: "3px solid #e5e7eb",
            borderRight: "3px solid #2563eb",
            borderRadius: "50%",
            animation: "spin 0.6s linear infinite reverse",
          }} />
        </div>
        
        {/* Loading Text */}
        <div style={{
          fontSize: "16px",
          fontWeight: "600",
          color: "#1e40af",
          marginBottom: "8px",
          letterSpacing: "0.5px",
        }}>
          Loading...
        </div>
        
        {/* Animated Dots */}
        <div style={{
          display: "flex",
          gap: "6px",
          alignItems: "center",
        }}>
          <div style={{
            width: "8px",
            height: "8px",
            borderRadius: "50%",
            backgroundColor: "#3b82f6",
            animation: "bounce 1.4s ease-in-out infinite",
            animationDelay: "0s",
          }} />
          <div style={{
            width: "8px",
            height: "8px",
            borderRadius: "50%",
            backgroundColor: "#3b82f6",
            animation: "bounce 1.4s ease-in-out infinite",
            animationDelay: "0.2s",
          }} />
          <div style={{
            width: "8px",
            height: "8px",
            borderRadius: "50%",
            backgroundColor: "#3b82f6",
            animation: "bounce 1.4s ease-in-out infinite",
            animationDelay: "0.4s",
          }} />
        </div>
        
        {/* CSS Animations */}
        <style>{`
          @keyframes shimmer {
            0% {
              transform: translateX(-100%);
            }
            100% {
              transform: translateX(400%);
            }
          }
          
          @keyframes spin {
            0% {
              transform: rotate(0deg);
            }
            100% {
              transform: rotate(360deg);
            }
          }
          
          @keyframes bounce {
            0%, 80%, 100% {
              transform: scale(0.8);
              opacity: 0.5;
            }
            40% {
              transform: scale(1.2);
              opacity: 1;
            }
          }
        `}</style>
      </div>
    );
  }
}
